import { render, staticRenderFns } from "./pbi.vue?vue&type=template&id=64847036&scoped=true&"
import script from "./pbi.vue?vue&type=script&lang=js&"
export * from "./pbi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64847036",
  null
  
)

export default component.exports